import * as Icons from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { INDUSTRIES } from "@/lib/siteData";

export const Industries = () => {
  return (
    <section id="industries" className="relative bg-gradient-subtle py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="mx-auto max-w-3xl text-center">
          <span className="mb-4 inline-block rounded-full bg-accent px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wider text-accent-foreground">
            Industries
          </span>
          <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl lg:text-5xl">
            One Platform. Endless Possibilities.
          </h2>
          <p className="mt-5 text-base text-muted-foreground md:text-lg">
            From home services to professional offices — Anchor Web Systems is built to perform for
            your industry.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
          {INDUSTRIES.map((ind, i) => {
            const Icon = Icons[ind.icon] || Icons.Briefcase;
            return (
              <Reveal key={ind.name} dir="scale" delay={(i % 6) * 0.04}>
                <div className="group flex h-full flex-col items-center gap-2.5 rounded-2xl border border-border bg-card p-4 text-center shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-techblue/40 hover:shadow-card">
                  <div className="grid h-11 w-11 place-items-center rounded-xl bg-accent text-primary transition-colors duration-300 group-hover:bg-gradient-blue group-hover:text-primary-foreground">
                    <Icon className="h-5 w-5" />
                  </div>
                  <span className="text-[12px] font-medium leading-tight text-navy">{ind.name}</span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
